import { match } from 'ts-pattern';
import type { SearchHeaderFormData_FreelancerEnum } from '$gql/graphql';
import { searchHeaderFormData_FreelancerEnumValues } from '$gql/zod-generated';
import type { Choice } from '$components/Form/Select.svelte';

export type Value = SearchHeaderFormData_FreelancerEnum;

export const values = searchHeaderFormData_FreelancerEnumValues;

export function valueToLabel(value: Value): string {
    return match(value)
        .with('all', () => 'Tous profils')
        .with('with', () => 'Profils freelance uniquement')
        .with('without', () => 'Pas de profils freelance')
        .exhaustive();
}

export const selectOptions: readonly Choice<Value>[] = values.map(valueToOption);

export function valueToOption(value: Value): Choice<Value> {
    return {
        value,
        key: value,
        label: valueToLabel(value),
    };
}
